export default "__VITE_ASSET__CoMexoqC__"